import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormField, FormFieldOption } from '../../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { DemandaService } from '../service/demanda.service';
import { Constants } from '../../../../constants/constants';
import { ListaDTO } from '../models/listaDTO';
import { ListasService } from '../../../../services/listas.service';
import { TipoPersonaDto } from '../../../../dto/expediente/tipo-persona-dto.dto';
import { AnexosConDemandaDTO, AnexosSinDemandaDTO } from '../models/anexosDTO';
import { MunicipioDto } from '../../../../dto/expediente/municipio.dto';
import { combineLatest, firstValueFrom, Observable } from 'rxjs';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { PersonaDTO } from '../models/personaDTO';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { RecaptchaService } from '../../../../services/util/recaptcha.service';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import {
  FielDatosPersonaJuridicaDTO,
  FielDatosPersonaNaturalDTO,
} from '../models/fieldDatosPersonaDTO';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { Router } from '@angular/router';
import { TablaDefinicionesComponent } from '../tabla-definiciones/tabla-definiciones.component';
import { InfoPantallaDTO } from '../../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../../services/util.service';
import { TipoDocumentoDto } from '../../../../dto/expediente/tipo-documento-dto.dto';
import { TramiteService } from '../../../../services/tramite.service';
import { TramiteDTO } from '../../models/tramiteDTO';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { TramiteSupersaludDTO } from '../models/tramiteSupersaludDTO';
import { Location } from '@angular/common';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { TranslateService } from '@ngx-translate/core';
import { TipoAnexoTipoTramiteDto } from '../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { CargueArchivosTramiteService } from '../../../util/archivos-tramite/services/cargue-archivos-tramite.service';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { DemandadoAuxDto } from "../../../../dto/tramites/demandado-aux.dto";
import { ConfigurarCuentasService } from '../../../configuracion-cuenta/services/configurar-cuentas.service';
import { LanguageService } from '../../../../services/util/language.service';
import { FormComponent } from '../../../util/form/form.component';

@Component({
  selector: 'app-crear-demanda-jurisdiccional',
  templateUrl: './crear-demanda-jurisdiccional.component.html',
  styleUrl: './crear-demanda-jurisdiccional.component.scss',
})
export class CrearDemandaJurisdiccionalComponent implements OnInit, OnDestroy {


  // ID entidad
  idiomaActual: string = 'es';
  entidadId = Constants.ID_ENTIDAD_SUPERSALUD;
  // Listas
  tiposPretension: FormFieldOption[] = [];
  listaTiposPretension: ListaDTO[] = [];
  tiposCasos: FormFieldOption[] = [];
  tipoCasoSeleccionado?: string;
  idTipoCasoSeleccionado?: number;
  listaTiposCasos: ListaDTO[] = [];
  tiposPersona: FormFieldOption[] = [];
  municipios: MunicipioDto[] = [];
  paises: PaisDto[] = [];
  tiposDocumento: TipoDocumentoDto[] = [];

  // Formulario inicial
  campoInicial: FormField[] = [];
  // Formulario tipo de apoderado
  campoApoderado: FormField[] = [];
  // Formularios apoderado PN
  datosBasicosApoderadoPN: FormField[] = [];
  ubicacionApoderadoPN: FormField[] = [];
  datosContactoApoderadoPN: FormField[] = [];
  tipoDocumento: unknown;
  numeroDocumento: unknown;
  // Formularios apoderado PJ
  datosBasicosApoderadoPJ: FormField[] = [];
  ubicacionApoderadoPJ: FormField[] = [];
  datosContactoApoderadoPJ: FormField[] = [];
  // Formulario tipo de demandante
  campoDemandante: FormField[] = [];
  // Formularios demandante PN
  datosBasicosDemandantePN: FormField[] = [];
  ubicacionDemandantePN: FormField[] = [];
  datosContactoDemandantePN: FormField[] = [];
  // Formularios demandante PJ
  datosBasicosDemandantePJ: FormField[] = [];
  ubicacionDemandantePJ: FormField[] = [];
  datosContactoDemandantePJ: FormField[] = [];
  // Formulario caso
  camposCaso: FormField[] = [];
  formularioCaso!: FormGroup;
  // Formulario final
  datosFinales: FormField[] = [];
  // Archivos
  camposArchivos: FormField[] = [];
  camposAceptarPoliticas: FormField[] = [];
  formularioAceptarPoliticas!: FormGroup;
  archivosPreCargados: AnexoPrecargaResponseDto[] = [];

  // Apoderado
  tipoApoderado!: unknown;
  idApoderado!: number;
  existeApoderado = false;
  tieneApoderado = false;

  // Boolean
  formInicialValido: boolean = false;
  mostrarApoderado: boolean = false;
  formApoderadoValido: boolean = false;
  mostrarDatosApoderadoPN: boolean = false;
  formDatosBasicosApoderadoValido: boolean = false;
  formUbicacionApoderadoValido: boolean = false;
  formContactoApoderadoValido: boolean = false;
  mostrarDatosApoderadoPJ: boolean = false;
  formDatosBasicosApoderadoPJValido: boolean = false;
  formUbicacionApoderadoPJValido: boolean = false;
  formContactoApoderadoPJValido: boolean = false;
  confirmacionEnvio = false;
  demandadoAux: DemandadoAuxDto = {};
  enviarCorreoDemandado: boolean = false;
  pesoTotalArchivosMB: string = '0.00';
  // Demandante
  tipoDemandante!: unknown;
  idDemandante!: number;
  formDemandanteValido: boolean = false;
  mostrarDatosDemandantePN: boolean = false;
  formDatosBasicosDemandanteValido: boolean = false;
  formUbicacionDemandanteValido: boolean = false;
  formContactoDemandanteValido: boolean = false;
  mostrarDatosDemandantePJ: boolean = false;
  formDatosBasicosDemandantePJValido: boolean = false;
  formUbicacionDemandantePJValido: boolean = false;
  formContactoDemandantePJValido: boolean = false;
  esDemandantePN: boolean = false;
  esDemandantePJ: boolean = false;
  jsonCasoDemanda!: AnexosConDemandaDTO | null;
  jsonCasoPretension!: AnexosSinDemandaDTO | null;
  // Recaptcha
  recaptchaValido: boolean = false;
  formularioFinal!: FormGroup;
  // ID usuario
  idUsuario!: number;

  private dataUsuario!: PersonaLoginDTO;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  // Trámite
  idTramite!: number;

  // Formularios válidos
  formulariosValidos = false;

  // Archivos validos
  archivosCargados = false;
  mostrarCargueArchivos = false;
  enviarDocumentos: boolean = false;
  filesUpload: ArchivoItemDto[] = [];

  // Constantes
  protected readonly Constants = Constants;
  protected readonly JSON = JSON;

  // Formularios apoderado
  formularioTipoApoderado!: FormGroup;
  formularioDatosBasicosApoderado!: FormGroup;
  formularioUbicacionApoderado!: FormGroup;
  formularioContactoApoderado!: FormGroup;
  formularioDatosBasicosApoderadoPJ!: FormGroup;
  formularioUbicacionApoderadoPJ!: FormGroup;
  formularioContactoApoderadoPJ!: FormGroup;

  // Formularios demandante
  formularioTipoDemandante!: FormGroup;
  formularioDatosBasicosDemandante!: FormGroup;
  formularioUbicacionDemandante!: FormGroup;
  formularioContactoDemandante!: FormGroup;
  formularioDatosBasicosDemandantePJ!: FormGroup;
  formularioUbicacionDemandantePJ!: FormGroup;
  formularioContactoDemandantePJ!: FormGroup;
  enviarEntidad: boolean = false;

  // Multilenguaje
  crearDemandaText: any = {};
  comunText: any = {};
  alertaText: any = {};
  // anexos para tramite
  anexosTramiteObligatorios: TipoAnexoTipoTramiteDto[] = [];

  auxIdCountryDemandantePN: number[] = [];
  auxIdCountryDemandantePJ: number[] = [];
  auxIdCountryApoderadoPJ: number[] = [];
  auxIdCountryApoderadoPN: number[] = [];

  nombreTramite: string | null = null;
  nombreCompleto: string = '';
  nombreCortoLimpio: string = '';
  nombreCortoProceso!: string;
  seleccionAceptoRechazoEnvio = false;
  proceso: string = '';
  entidad: string = '';

  @ViewChildren(FormComponent) personaComponentes!: QueryList<FormComponent>;

  constructor(
    private readonly demandaService: DemandaService,
    private readonly listaService: ListasService,
    private readonly modalService: AlertaModalService,
    private readonly recaptchaV3Service: ReCaptchaV3Service,
    private readonly recaptchaService: RecaptchaService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly tramiteService: TramiteService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly cargueArchivosTramiteService: CargueArchivosTramiteService,
    private readonly textTransformService: TextTransformService,
    private readonly _cuentaService: ConfigurarCuentasService,
    private languageService: LanguageService,
  ) {
    const data =
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ||
      localStorage.getItem(Constants.USER_INFORMATION_STORAGE);

    this.dataUsuario = data ? JSON.parse(data) : null;
  }

  ngOnInit(): void {
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
    ]).subscribe(([tramitesText, comunLabelText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.crearDemandaText[key] = tramitesText[key];
      }

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }
      this.inicializarFormulario();
    });
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    const nombreCorto = this.getStorageItem(Constants.TRAMITE_SELECCIONADO);
    this.nombreTramite = this.getStorageItem(Constants.NOMBRE_TRAMITE);
    this.nombreCompleto = (this.nombreTramite && Constants.NOMBRES_MAP[this.nombreTramite]) || this.nombreTramite || '';
    if (!nombreCorto) {
      console.warn('No hay Nombre_Corto en sessionStorage.');
      return;
    } else {
      this.nombreCortoProceso = nombreCorto;
    }
    this.tramiteService.obtenerNombreEntidadPorIdNombreCorto(Constants.ID_ENTIDAD_SUPERSALUD, nombreCorto).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });
    this.nombreCortoLimpio = nombreCorto.trim().replace(/^"|"$/g, '').toUpperCase();

    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    // Evento de recargar o cerrar pestaña
    // window.addEventListener('beforeunload', this.unloadNotification);
    // Se obtiene el ID del
    const dataSesion =
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ||
      localStorage.getItem(Constants.USER_INFORMATION_STORAGE);

    if (dataSesion) {
      const jsonSesion = JSON.parse(dataSesion);
      this.idUsuario = Number(jsonSesion.idUsuario);
    }
    // Se consume el servicio de listar paises
    this.listaService.getCountryList().subscribe((pais: PaisDto[]) => {
      this.paises = pais;
      this.inicializarFormulario();
    });

    // Se consume el servicio de listar los tipos de persona
    this.listaService
      .getTipoDePersonaList()
      .subscribe((resp: TipoPersonaDto[]) => {
        this.tiposPersona = resp.map(item => ({
          Id: item.Id,
          Nombre: item.Tipo_Persona,
        }));
        this.inicializarFormulario();
      });
    // Se consume el servicio para listar los tipos de documentos
    this.listaService
      .getDocumentTypeList()
      .subscribe((resp: TipoDocumentoDto[]) => {
        this.tiposDocumento = resp;
      });

    // Se consume el servicio de demanda para listar los tipo de pretensión
    this.demandaService
      .listasValor(Constants.tipo_pretension)
      .subscribe((resp: ListaDTO[]) => {
        this.listaTiposPretension = resp;
        this.tiposPretension = resp.map(item => ({
          Id: item.Id,
          Nombre: item.Valor,
        }));
        const tramitePretensionMap: { [key: string]: string } = {
          'SSA_COBSER': 'TP_PBS',
          'SSA_CONF_DEV': 'TP_DGRPBS',
          'SSA_CONF_ENT': 'TP_EAPRES',
          'LIB_ELEASE': 'TP_LEM',
          'SSA_MULTIAF': 'TP_SGSSS',
          'SSA_REC_ECON': 'TP_REGS'
        };
        const codigoPretension = tramitePretensionMap[this.nombreCortoLimpio];
        const pretensionSeleccionada = this.listaTiposPretension.find(item => item.Codigo === codigoPretension);
        if (!pretensionSeleccionada) {
          console.warn(`No se encontró una pretensión para el código: "${codigoPretension}" en listaTiposPretension.`);
          return;
        }
        this.tiposPretension = this.tiposPretension.filter(option => option.Id === pretensionSeleccionada.Id);
        this.inicializarFormulario();
        this.tipoCasoSeleccionado = pretensionSeleccionada?.Codigo;
        this.idTipoCasoSeleccionado = pretensionSeleccionada?.Id;
        this.mostrarCargueArchivos = false;
        setTimeout(() => {
          this.mostrarCargueArchivos = true;
        }, 100);
      });

    // Se consume el servicio de demanda para listar los casos de acuerdo al tipo de demanda
    this.demandaService
      .listasValor(Constants.casos_tipo_demanda)
      .subscribe((resp: ListaDTO[]) => {
        this.listaTiposCasos = resp;
        this.tiposCasos = resp.map(item => ({
          Id: item.Id,
          Nombre: item.Valor,
        }));
        this.inicializarFormulario();
      });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de radicar demanda jurisdiccional en la entidad Superintendencia ' +
        'de Salud',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un Proceso de radicar demanda jurisdiccional ' +
        'en la Superintendencia de Salud',
      pasos: [],
      // Evento en el botón volver
      change: async op =>
        await this.guardarAntesDeSalir(this.modalService, this.location, op),
    };
    // Consultar si existe un trámite pendiente
    this.utilService.changeInfoPantalla(this.infoPantalla);
    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        this.dataUsuario?.idUsuario!,
        this.nombreCortoLimpio
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.modalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              // this.dataUsuario = undefined;
              this.consultarTramitePorID(resp.Id);
            },
            () => {
              this.mostrarDatosDemandantePN = true;
              this.getDataUsuario();
            },
            true
          );
        } else {
          this.mostrarDatosDemandantePN = true;
          this.getDataUsuario();
        }
      });
    this.getAnexosTramite(Constants.ID_TIPO_TRAMITE);
  }

  // Función para mostrar alerta antes de salir de la pantalla
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.guardarTramite(false);
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  ngOnDestroy(): void {
    // Evento de recargar o cerrar pestaña
    // window.addEventListener('beforeunload', this.unloadNotification);
  }

  consultarTramitePorID(id: number) {
    this.idTramite = id;
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          if (resp.anexos) {
            this.archivosPreCargados = resp.anexos;
          }
          if (resp.apoderado) {
            this.tieneApoderado = true;
            if (resp.apoderado.idTipoPersona) {
              this.formApoderadoValido = true;
              this.mostrarApoderado = true;
              this.tipoApoderado = resp.apoderado.idTipoPersona;
              this.idApoderado = resp.apoderado.id;
            }
            if (resp.apoderado.esApoderado) {
              this.campoInicial = this.campoInicial.map((field: FormField) => {
                switch (field.name) {
                  case 'apoderado':
                    field.value = 1;
                    break;
                }
                return field;
              });
              this.campoApoderado = this.campoApoderado.map(
                (field: FormField) => {
                  switch (field.name) {
                    case 'tipoPersonaApoderado':
                      field.value = resp.apoderado.idTipoPersona;
                      break;
                  }
                  return field;
                }
              );
              if (resp.apoderado.idTipoPersona === 1) {
                this.mostrarDatosApoderadoPN = true;
                this.mostrarDatosApoderadoPJ = false;
                // Se setean datos básicos del apoderado
                this.datosBasicosApoderadoPN = this.datosBasicosApoderadoPN.map(
                  (field: FormField) => {
                    switch (field.name) {
                      case 'typeOfDocument':
                        field.value = resp.apoderado.idTipoIdentificacion
                          ? resp.apoderado.idTipoIdentificacion
                          : undefined;
                        break;
                      case 'numberOfDocument':
                        field.value = resp.apoderado.identificacion
                          ? resp.apoderado.identificacion
                          : undefined;
                        break;
                      case 'primerNombreApoderado':
                        field.value = resp.apoderado.primerNombre
                          ? resp.apoderado.primerNombre
                          : undefined;
                        break;
                      case 'segundoNombreApoderado':
                        field.value = resp.apoderado.segundoNombre
                          ? resp.apoderado.segundoNombre
                          : undefined;
                        break;
                      case 'primerApellidoApoderado':
                        field.value = resp.apoderado.primerApellido
                          ? resp.apoderado.primerApellido
                          : undefined;
                        break;
                      case 'segundoApellidoApoderado':
                        field.value = resp.apoderado.segundoApellido
                          ? resp.apoderado.segundoApellido
                          : undefined;
                        break;
                    }
                    return field;
                  }
                );
                // Se setean datos ubicación del apoderado
                setTimeout(() => {
                  this.ubicacionApoderadoPN = this.ubicacionApoderadoPN.map(
                    (field: FormField) => {
                      switch (field.name) {
                        case 'country':
                          field.value = resp.apoderado.municipio.idPais
                            ? resp.apoderado.municipio.idPais
                            : undefined;
                          break;
                        case 'departament':
                          field.value = resp.apoderado.municipio.idDepartamento
                            ? resp.apoderado.municipio.idDepartamento
                            : undefined;
                          break;
                        case 'municipality':
                          field.value = resp.apoderado.municipio.id
                            ? resp.apoderado.municipio.id
                            : undefined;
                          break;
                        case 'otroMunicipioApoderado':
                          field.value = resp.apoderado.ciudadExtranjero
                            ? resp.apoderado.ciudadExtranjero
                            : undefined;
                          break;
                        case 'otroDepartamentoApoderado':
                          field.value = resp.apoderado.departamentoExtranjero
                            ? resp.apoderado.departamentoExtranjero
                            : undefined;
                          break;
                        case 'direccionApoderado':
                          field.value = resp.apoderado.direccionPersona[0]
                            .direccionNotificacion
                            ? resp.apoderado.direccionPersona[0]
                              .direccionNotificacion
                            : undefined;
                          break;
                      }
                      return field;
                    }
                  );
                }, 1000);

                // Se setean datos contacto del apoderado
                this.datosContactoApoderadoPN =
                  this.datosContactoApoderadoPN.map((field: FormField) => {
                    switch (field.name) {
                      case 'celularApoderado':
                        field.value = resp.apoderado.telefonoPrincipal
                          ? resp.apoderado.telefonoPrincipal
                          : undefined;
                        break;
                      case 'telefonoApoderado':
                        field.value = resp.apoderado.telefonoSecundario
                          ? resp.apoderado.telefonoSecundario
                          : undefined;
                        break;
                      case 'correoElectronicoApoderado':
                        field.value = resp.apoderado.correoElectronico
                          ? resp.apoderado.correoElectronico
                          : undefined;
                        break;
                    }
                    return field;
                  });
              } else if (resp.apoderado.idTipoPersona === 2) {
                this.mostrarDatosApoderadoPJ = true;
                this.mostrarDatosApoderadoPN = false;
                // Se setean datos básicos del apoderado persona jurídica
                this.datosBasicosApoderadoPJ = this.datosBasicosApoderadoPJ.map(
                  (field: FormField) => {
                    switch (field.name) {
                      case 'typeOfDocument':
                        field.value = resp.apoderado.idTipoIdentificacion
                          ? resp.apoderado.idTipoIdentificacion
                          : undefined;
                        break;
                      case 'numberOfDocument':
                        field.value = resp.apoderado.identificacion
                          ? resp.apoderado.identificacion
                          : undefined;
                        break;
                      case 'razonSocial':
                        field.value = resp.apoderado.razonSocial
                          ? resp.apoderado.razonSocial
                          : undefined;
                        break;
                    }
                    return field;
                  }
                );
                // Se setean datos ubicación del apoderado persona jurídica
                setTimeout(() => {
                  this.ubicacionApoderadoPJ = this.ubicacionApoderadoPJ.map(
                    (field: FormField) => {
                      switch (field.name) {
                        case 'country':
                          field.value = resp.apoderado.municipio.idPais
                            ? resp.apoderado.municipio.idPais
                            : undefined;
                          break;
                        case 'departament':
                          field.value = resp.apoderado.municipio.idDepartamento
                            ? resp.apoderado.municipio.idDepartamento
                            : undefined;
                          break;
                        case 'municipality':
                          field.value = resp.apoderado.municipio.id
                            ? resp.apoderado.municipio.id
                            : undefined;
                          break;
                        case 'otroMunicipioApoderadoPJ':
                          field.value = resp.apoderado.ciudadExtranjero
                            ? resp.apoderado.ciudadExtranjero
                            : undefined;
                          break;
                        case 'otroDepartamentoApoderadoPJ':
                          field.value = resp.apoderado.departamentoExtranjero
                            ? resp.apoderado.departamentoExtranjero
                            : undefined;
                          break;
                        case 'direccionApoderadoPJ':
                          field.value = resp.apoderado.direccionPersona[0]
                            .direccionNotificacion
                            ? resp.apoderado.direccionPersona[0]
                              .direccionNotificacion
                            : undefined;
                          break;
                      }
                      return field;
                    }
                  );
                }, 1000);

                // Se setean datos contacto del apoderado persona jurídica
                this.datosContactoApoderadoPJ =
                  this.datosContactoApoderadoPJ.map((field: FormField) => {
                    switch (field.name) {
                      case 'celularApoderadoPJ':
                        field.value = resp.apoderado.telefonoPrincipal
                          ? resp.apoderado.telefonoPrincipal
                          : undefined;
                        break;
                      case 'telefonoApoderadoPJ':
                        field.value = resp.apoderado.telefonoSecundario
                          ? resp.apoderado.telefonoSecundario
                          : undefined;
                        break;
                      case 'correoElectronicoApoderadoPJ':
                        field.value = resp.apoderado.correoElectronico
                          ? resp.apoderado.correoElectronico
                          : undefined;
                        break;
                    }
                    return field;
                  });
              }
            } else {
              this.tieneApoderado = false;
              this.campoInicial = this.campoInicial.map((field: FormField) => {
                switch (field.name) {
                  case 'apoderado':
                    field.value = 2;
                    break;
                }
                return field;
              });
            }
          } else {
            this.tieneApoderado = false;
            // this.mostrarApoderado = false;
            this.campoInicial = this.campoInicial.map((field: FormField) => {
              switch (field.name) {
                case 'apoderado':
                  field.value = 2;
                  break;
              }
              return field;
            });
          }
          if (resp.demandante.length > 0) {
            this.idDemandante = resp.demandante[0].id;
            this.mostrarDatosDemandantePN = true;
            this.campoDemandante = this.campoDemandante.map(
              (field: FormField) => {
                switch (field.name) {
                  case 'tipoPersonaDemandante':
                    field.value = resp.demandante[0].idTipoPersona;
                    break;
                }
                return field;
              }
            );
            if (resp.demandante[0].idTipoPersona === 1) {
              this.mostrarDatosDemandantePN = true;
              this.mostrarDatosDemandantePJ = false;
              // Se setean datos básicos del demandante
              this.datosBasicosDemandantePN = this.datosBasicosDemandantePN.map(
                (field: FormField) => {
                  switch (field.name) {
                    case 'typeOfDocument':
                      field.value = resp.demandante[0].idTipoIdentificacion
                        ? resp.demandante[0].idTipoIdentificacion
                        : undefined;
                      break;
                    case 'numberOfDocument':
                      field.value = resp.demandante[0].identificacion
                        ? resp.demandante[0].identificacion
                        : undefined;
                      break;
                    case 'primerNombreDemandante':
                      field.value = resp.demandante[0].primerNombre
                        ? resp.demandante[0].primerNombre
                        : undefined;
                      break;
                    case 'segundoNombreDemandante':
                      field.value = resp.demandante[0].segundoNombre
                        ? resp.demandante[0].segundoNombre
                        : undefined;
                      break;
                    case 'primerApellidoDemandante':
                      field.value = resp.demandante[0].primerApellido
                        ? resp.demandante[0].primerApellido
                        : undefined;
                      break;
                    case 'segundoApellidoDemandante':
                      field.value = resp.demandante[0].segundoApellido
                        ? resp.demandante[0].segundoApellido
                        : undefined;
                      break;
                  }
                  return field;
                }
              );
              // Se setean datos ubicación del demandante
              setTimeout(() => {
                this.ubicacionDemandantePN = this.ubicacionDemandantePN.map(
                  (field: FormField) => {
                    switch (field.name) {
                      case 'country':
                        field.value = resp.demandante[0].municipio.idPais
                          ? resp.demandante[0].municipio.idPais
                          : undefined;
                        break;
                      case 'departament':
                        field.value = resp.demandante[0].municipio
                          .idDepartamento
                          ? resp.demandante[0].municipio.idDepartamento
                          : undefined;
                        break;
                      case 'municipality':
                        field.value = resp.demandante[0].municipio.id
                          ? resp.demandante[0].municipio.id
                          : undefined;
                        break;
                      case 'departamentoDemandante':
                        field.value = resp.demandante[0].departamentoExtranjero
                          ? resp.demandante[0].departamentoExtranjero
                          : undefined;
                        break;
                      case 'otroMunicipioDemandante':
                        field.value = resp.demandante[0].ciudadExtranjero
                          ? resp.demandante[0].ciudadExtranjero
                          : undefined;
                        break;
                      case 'direccionDemandante':
                        field.value = resp.demandante[0].direccionPersona[0]
                          .direccionNotificacion
                          ? resp.demandante[0].direccionPersona[0]
                            .direccionNotificacion
                          : undefined;
                        break;
                    }
                    return field;
                  }
                );
              }, 1000);

              // Se setean datos contacto del demandante
              this.datosContactoDemandantePN =
                this.datosContactoDemandantePN.map((field: FormField) => {
                  switch (field.name) {
                    case 'celularDemandante':
                      field.value = resp.demandante[0].telefonoPrincipal
                        ? resp.demandante[0].telefonoPrincipal
                        : undefined;
                      break;
                    case 'telefonoDemandante':
                      field.value = resp.demandante[0].telefonoSecundario
                        ? resp.demandante[0].telefonoSecundario
                        : undefined;
                      break;
                    case 'correoElectronicoDemandante':
                      field.value =
                        resp.demandante[0].correoElectronico === null
                          ? undefined
                          : resp.demandante[0].correoElectronico;
                      break;
                  }
                  return field;
                });
            } else if (resp.demandante[0].idTipoPersona === 2) {
              this.mostrarDatosDemandantePJ = true;
              this.mostrarDatosDemandantePN = false;
              // Se setean datos básicos del demandante persona jurídica
              this.datosBasicosDemandantePJ = this.datosBasicosDemandantePJ.map(
                (field: FormField) => {
                  switch (field.name) {
                    case 'typeOfDocument':
                      field.value = resp.demandante[0].idTipoIdentificacion
                        ? resp.demandante[0].idTipoIdentificacion
                        : undefined;
                      break;
                    case 'numberOfDocument':
                      field.value = resp.demandante[0].identificacion
                        ? resp.demandante[0].identificacion
                        : undefined;
                      break;
                    case 'razonSocialDemandante':
                      field.value = resp.demandante[0].razonSocial
                        ? resp.demandante[0].razonSocial
                        : undefined;
                      break;
                  }
                  return field;
                }
              );
              // Se setean datos ubicación del demandante persona jurídica
              setTimeout(() => {
                this.ubicacionDemandantePJ = this.ubicacionDemandantePJ.map(
                  (field: FormField) => {
                    switch (field.name) {
                      case 'country':
                        field.value = resp.demandante[0].municipio.idPais
                          ? resp.demandante[0].municipio.idPais
                          : undefined;
                        break;
                      case 'departament':
                        field.value = resp.demandante[0].municipio
                          .idDepartamento
                          ? resp.demandante[0].municipio.idDepartamento
                          : undefined;
                        break;
                      case 'municipality':
                        field.value = resp.demandante[0].municipio.id
                          ? resp.demandante[0].municipio.id
                          : undefined;
                        break;
                      case 'otroMunicipioDemandantePJ':
                        field.value = resp.demandante[0].ciudadExtranjero
                          ? resp.demandante[0].ciudadExtranjero
                          : undefined;
                        break;
                      case 'departamentoDemandantePJ':
                        field.value = resp.demandante[0].departamentoExtranjero
                          ? resp.demandante[0].departamentoExtranjero
                          : undefined;
                        break;
                      case 'direccionDemandantePJ':
                        field.value = resp.demandante[0].direccionPersona[0]
                          .direccionNotificacion
                          ? resp.demandante[0].direccionPersona[0]
                            .direccionNotificacion
                          : undefined;
                        break;
                      case 'direccionComercialDemandantePJ':
                        field.value = resp.demandante[0].direccionPersona[1]
                          .direccionNotificacion
                          ? resp.demandante[0].direccionPersona[1]
                            .direccionNotificacion
                          : undefined;
                        break;
                    }
                    return field;
                  }
                );
              }, 1000);

              // Se setean datos contacto del demandante persona jurídica
              this.datosContactoDemandantePJ =
                this.datosContactoDemandantePJ.map((field: FormField) => {
                  switch (field.name) {
                    case 'celularDemandantePJ':
                      field.value = resp.demandante[0].telefonoPrincipal
                        ? resp.demandante[0].telefonoPrincipal
                        : undefined;
                      break;
                    case 'telefonoDemandantePJ':
                      field.value = resp.demandante[0].telefonoSecundario
                        ? resp.demandante[0].telefonoSecundario
                        : undefined;
                      break;
                    case 'correoElectronicoDemandantePJ':
                      field.value = resp.demandante[0].correoElectronico
                        ? resp.demandante[0].correoElectronico
                        : undefined;
                      break;
                  }
                  return field;
                });
            }
          } else {
            this.mostrarDatosDemandantePN = true;
            this.getDataUsuario();
          }
          const tramitePretensionMap: { [key: string]: string } = {
            'SSA_COBSER': 'TP_PBS',
            'SSA_CONF_DEV': 'TP_DGRPBS',
            'SSA_CONF_ENT': 'TP_EAPRES',
            'LIB_ELEASE': 'TP_LEM',
            'SSA_MULTIAF': 'TP_SGSSS',
            'SSA_REC_ECON': 'TP_REGS'
          };
          const codigoPretension = tramitePretensionMap[this.nombreCortoLimpio];
          const pretensionSeleccionada = this.listaTiposPretension.find(item => item.Codigo === codigoPretension);
          // Se setean datos del detalle del caso
          if (resp.tipoPretension) {
            this.camposCaso = this.camposCaso.map((field: FormField) => {
              switch (field.name) {
                case 'tipoPretension':
                  field.value = pretensionSeleccionada?.Id;
                  setTimeout(() => {
                    this.mostrarCargueArchivos = true;
                  }, 100);
                  break;
              }
              return field;
            });
          }

          // Se setean datos del detalle del caso
          if (resp.detalleDemanda) {
            this.camposCaso = this.camposCaso.map((field: FormField) => {
              switch (field.name) {
                case 'descripcionDemanda':
                  field.value = resp.detalleDemanda;
                  setTimeout(() => {
                    this.mostrarCargueArchivos = true;
                  }, 100);
                  break;
              }
              return field;
            });
          }

          // Se setean datos del detalle del caso
          if (resp.tipoDemanda) {
            this.camposCaso = this.camposCaso.map((field: FormField) => {
              switch (field.name) {
                case 'tipoCaso':
                  field.value = Number(resp.tipoDemanda.Id);
                  const listaPretension = this.listaTiposPretension.find(
                    item => item.Id == Number(resp.tipoDemanda.Id)
                  );
                  this.tipoCasoSeleccionado = listaPretension?.Codigo;
                  setTimeout(() => {
                    this.mostrarCargueArchivos = true;
                  }, 100);
                  break;
              }
              return field;
            });
          }

          // Se setean datos del detalle del caso
          if (resp.medioEnvio) {
            this.datosFinales = this.datosFinales.map((field: FormField) => {
              switch (field.name) {
                case 'medioEnvio':
                  field.value = resp.medioEnvio ? resp.medioEnvio : undefined;
                  break;
              }
              return field;
            });
          }
          if (resp.aceptoPoliticas) {
            this.camposAceptarPoliticas = this.camposAceptarPoliticas.map((field: FormField) => {
              switch (field.name) {
                case 'politicas':
                  field.value = resp.aceptoPoliticas ? resp.aceptoPoliticas : undefined;
                  break;
              }
              return field;
            });
          }
          if (resp.aceptoEnvioCopiaDemanda) {
            this.confirmacionEnvio = resp.aceptoEnvioCopiaDemanda ? resp.aceptoEnvioCopiaDemanda : false;
          }
        }
      });
  }

  inicializarFormulario() {
    // Campo inicial
    this.campoInicial = [
      {
        name: 'apoderado',
        label: this.comunText['utiliza-abogado'],
        type: 'radio',
        required: true,
        width: '12',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['tool-tip-apoderado-si'] +
          this.crearDemandaText['crear-demanda']['tool-tip-apoderado-no'],
      },
    ];
    // Información del apoderado
    this.campoApoderado = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['inforrmacion-apoderado'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'tipoPersonaApoderado',
        label: this.crearDemandaText['crear-demanda']['tipo-persona-apoderado'],
        type: 'radio',
        required: true,
        width: '12',
        options: this.tiposPersona,
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'tooltip-tipo-persona-apoderado'
          ],
      },
    ];
    // Información del apoderado o agente oficioso persona natural
    this.datosBasicosApoderadoPN = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['informacion-datos'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        width: '6',
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-type-of-document'],
        multiple: false,
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
          maxlength:
            this.crearDemandaText['crear-demanda'][
            'numero-documento-maxlength'
            ],
          pattern: this.comunText['numero-documento-pattern'],
          mismoDocumento: this.comunText['mismoDocumento']
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-numero-documento'],
      },
      {
        name: 'primerNombreApoderado',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['primer-nombre-placeholder'],
      },
      {
        name: 'segundoNombreApoderado',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['segundo-nombre-placeholder'],
      },
      {
        name: 'primerApellidoApoderado',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['primer-apellido-placeholder'],
      },
      {
        name: 'segundoApellidoApoderado',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['segundo-apellido-placeholder'],
      },
    ];
    this.ubicacionApoderadoPN = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['domicilio'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['country-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-pais-reside'],
        multiple: false,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['departament-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'seleccione-departamento-reside'
          ],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['municipality-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-municipio-reside'],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamentoApoderado',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioApoderado',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionApoderado',
        label: this.comunText['direccion-notificacion-judicial'],
        placeholder:
          this.crearDemandaText['crear-demanda']['digite-residencia'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-residencia'],
      },
    ];
    this.datosContactoApoderadoPN = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['datos-contacto'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'celularApoderado',
        label: this.crearDemandaText['crear-demanda']['telefono-celular'],
        placeholder: this.crearDemandaText['crear-demanda']['digite-telefono'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono'],
      },
      {
        name: 'telefonoApoderado',
        label: this.crearDemandaText['crear-demanda']['telefono-o-celular'],
        placeholder:
          this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
      },
      {
        name: 'correoElectronicoApoderado',
        label: this.comunText['email'],
        placeholder: this.comunText['email-placeholder'],
        type: 'email',
        required: true,
        width: '6',
        validation: [Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO)],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
        },
        tooltip: this.comunText['email-placeholder'],
      },
    ];
    // Información del apoderado o agente oficioso persona jurídica
    this.datosBasicosApoderadoPJ = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['informacion-datos'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        personTypeId: '2',
        width: '6',
        errorMessages: {
          required: this.comunText['tipo-documento-required'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-type-of-document'],
        multiple: false,
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength:
            this.crearDemandaText['crear-demanda'][
            'numero-documento-maxlength'
            ],
          pattern: this.comunText['numero-documento-pattern'],
          mismoDocumento: this.comunText['mismoDocumento']
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-number-of-document'],
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
    ];
    this.ubicacionApoderadoPJ = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['domicilio'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['country-required'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-pais-reside'],
        multiple: false,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['departament-required'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'seleccione-departamento-reside'
          ],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['municipality-required'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-municipio-reside'],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'otroDepartamentoApoderadoPJ',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioApoderadoPJ',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionApoderadoPJ',
        label: this.comunText['direccion-notificacion-judicial'],
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        tooltip: this.comunText['direccion-notificacion-judicial-placeholder'],
      },
    ];
    this.datosContactoApoderadoPJ = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['datos-contacto'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'celularApoderadoPJ',
        label: this.crearDemandaText['crear-demanda']['telefono-celular'],
        placeholder: this.crearDemandaText['crear-demanda']['digite-telefono'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono'],
      },
      {
        name: 'telefonoApoderadoPJ',
        label: this.crearDemandaText['crear-demanda']['telefono-o-celular'],
        placeholder:
          this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
      },
      {
        name: 'correoElectronicoApoderadoPJ',
        label: this.comunText['email'],
        placeholder: this.comunText['email-placeholder'],
        type: 'email',
        required: true,
        width: '6',
        validation: [Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO)],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
        },
        tooltip: this.comunText['email-placeholder'],
      },
    ];
    // Información del demandante
    this.campoDemandante = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['informacion-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'tipoPersonaDemandante',
        label: this.crearDemandaText['crear-demanda']['informacion-demandante'],
        type: 'radio',
        required: true,
        width: '6',
        options: this.tiposPersona,
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'tooltip-tipo-persona-demandante'
          ],
        value: this.dataUsuario?.tipoPersona,
      },
    ];
    // Información del demandante persona natural
    this.datosBasicosDemandantePN = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['cuentenos-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-type-of-document'],
        personTypeId: '1',
        multiple: false,
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
          pattern: this.comunText['numero-documento-pattern'],
          mismoDocumento: this.comunText['mismoDocumento']
        },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-numero-documento'],
      },
      {
        name: 'primerNombreDemandante',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['primer-nombre-placeholder'],
      },
      {
        name: 'segundoNombreDemandante',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['segundo-nombre-placeholder'],
      },
      {
        name: 'primerApellidoDemandante',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          required: this.comunText['primer-apellido-required'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['primer-apellido-placeholder'],
      },
      {
        name: 'segundoApellidoDemandante',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
        tooltip: this.comunText['segundo-apellido-placeholder'],
      },
    ];
    this.ubicacionDemandantePN = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['domicilio'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['country-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-pais-reside'],
        multiple: false,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['departament-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'seleccione-departamento-reside'
          ],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['municipality-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-municipio-reside'],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'departamentoDemandante',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandante',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionDemandante',
        label: this.comunText['direccion-notificacion-judicial'],
        placeholder:
          this.crearDemandaText['crear-demanda']['direccion-residencia'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-residencia'],
      },
    ];
    this.datosContactoDemandantePN = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['contacto-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'celularDemandante',
        label: this.crearDemandaText['crear-demanda']['telefono-celular'],
        placeholder: this.crearDemandaText['crear-demanda']['digite-telefono'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono'],
      },
      {
        name: 'telefonoDemandante',
        label: this.crearDemandaText['crear-demanda']['telefono-o-celular'],
        placeholder:
          this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
      },
      {
        name: 'correoElectronicoDemandante',
        label: this.comunText['email'],
        placeholder: this.comunText['email-placeholder'],
        type: 'email',
        required: true,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(80),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.crearDemandaText['crear-demanda']['correo-maxlength'],
        },
        tooltip: this.comunText['email-placeholder'],
      },
    ];
    // Información del demandante persona jurídica
    this.datosBasicosDemandantePJ = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['cuentenos-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        width: '6',
        personTypeId: '2',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-type-of-document'],
        multiple: false,
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(9)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          mismoDocumento: this.comunText['mismoDocumento']
        },
        personTypeId: '2',
        tooltip:
          this.crearDemandaText['crear-demanda']['tooltip-numero-documento'],
      },
      {
        name: 'razonSocialDemandante',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
    ];
    this.ubicacionDemandantePJ = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['domicilio'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['country-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-pais-reside'],
        multiple: false,
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['departament-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'seleccione-departamento-reside'
          ],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'municipality',
        label: 'Municipio/ciudad ',
        type: 'select',
        required: true,
        width: '6',
        errorMessages: { required: this.comunText['municipality-required'] },
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-municipio-reside'],
        multiple: false,
        dependsOn: 'country',
        visibilityCondition: value =>
          value ==
          this.paises.find(item => item.Codigo == Constants.CODIGO_COLOMBIA)
            ?.Id,
      },
      {
        name: 'departamentoDemandantePJ',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandantePJ',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [Validators.maxLength(30)],
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
          maxlength: this.crearDemandaText['crear-demanda']['campo-maxlength'],
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.crearDemandaText['crear-demanda']['escriba-municipio'],
      },
      {
        name: 'direccionDemandantePJ',
        label: this.comunText['direccion-notificacion-judicial'],
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        tooltip: this.comunText['direccion-notificacion-judicial-placeholder'],
      },
      {
        name: 'direccionComercialDemandantePJ',
        label: this.crearDemandaText['crear-demanda']['direccion-comercial'],
        placeholder:
          this.crearDemandaText['crear-demanda'][
          'direccion-comercial-placeholder'
          ],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
        tooltip:
          this.crearDemandaText['crear-demanda'][
          'direccion-comercial-placeholder'
          ],
      },
    ];
    this.datosContactoDemandantePJ = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['datos-contacto-demandante'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'celularDemandantePJ',
        label: this.crearDemandaText['crear-demanda']['telefono-celular'],
        placeholder: this.crearDemandaText['crear-demanda']['digite-telefono'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono'],
      },
      {
        name: 'telefonoDemandantePJ',
        label: this.crearDemandaText['crear-demanda']['telefono-o-celular'],
        placeholder:
          this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
          pattern: this.comunText['telefono-pattern'],
        },
        tooltip: this.crearDemandaText['crear-demanda']['digite-telefono-fijo'],
      },
      {
        name: 'correoElectronicoDemandantePJ',
        label: this.comunText['email'],
        placeholder: this.comunText['email-placeholder'],
        type: 'email',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(80),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.crearDemandaText['crear-demanda']['correo-maxlength'],
        },
        tooltip: this.comunText['email-placeholder'],
      },
    ];
    // Archivos
    this.camposArchivos = [
      {
        isSubtitle: true,
        subtitleText: this.crearDemandaText['crear-demanda']['anexos-demanda'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
    ];
    // Descripción del caso
    this.camposCaso = [
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['descripcion-caso'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        isSubtitle: true,
        subtitleText:
          this.crearDemandaText['crear-demanda']['informacion-demanda'],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-tipo-demanda'],
      },

      {
        name: 'tipoPretension',
        label: this.crearDemandaText['crear-demanda']['asunto'],
        type: 'select',
        required: true,
        width: '6',
        // disabled: true,
        options: this.tiposPretension,
        value: this.tiposPretension[0]?.Id,
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
        },
        multiple: false,
        tooltip:
          this.crearDemandaText['crear-demanda']['seleccione-tipo-demanda'],
        modalVisibility: true,
        titleModal: this.crearDemandaText['crear-demanda']['tipo-demanda'],
        sizeModal: 'xl',
        contentTypeModal: 'component',
      },
      {
        name: 'tipoCaso',
        label: this.crearDemandaText['crear-demanda']['caso-tipo-demanda'],
        type: 'select',
        required: false,
        width: '6',
        options: this.tiposCasos,
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
        },
        visible: false,
        dependsOn: 'tipoPretension',
        visibilityCondition: value =>
          value ==
          this.listaTiposPretension.find(field => field.Codigo === 'TP_DGRPBS')
            ?.Id,
        multiple: false,
      },
      {
        name: 'descripcionDemanda',
        label: this.crearDemandaText['crear-demanda']['descripcion-demanda'],
        type: 'textarea',
        placeholder: '',
        noConvertToUpperCase: true,
        required: true,
        width: '12',
        errorMessages: {
          required: this.crearDemandaText['crear-demanda']['campo-requerido'],
        },
      },
    ];

    // Formulario final
    this.datosFinales = [
      {
        name: 'medioEnvio',
        label: this.crearDemandaText['crear-demanda']['medio-envio'],
        type: 'radio',
        options: [
          { Id: 'correoElectronico', Nombre: this.comunText['email'] },
          {
            Id: 'direccionCorrespondencia',
            Nombre:
              this.crearDemandaText['crear-demanda']['medio-envio-opcion'],
          },
        ],
        required: true,
      },
    ];

    //Formulario para aceptar politicas
    this.camposAceptarPoliticas = [
      {
        name: 'politicas',
        label: '',
        type: 'checkbox',
        options: [
          {
            Id: 1,
            Nombre: this.crearDemandaText['crear-demanda']['aceptar-politicas'],
          },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.crearDemandaText['seleccione'] },
      },
    ];
  }

  // Metodo que filtra el tipo de documentos para apoderado, quitando TI
  getListaDocumentosApoderado() {
    this.datosBasicosApoderadoPN = this.datosBasicosApoderadoPN.map(
      (field: FormField) => {
        if (field.name === 'typeOfDocument' && field.options?.length) {
          const filteredOptions =
            field.options?.filter(option => option.Id !== 5) || [];
          return { ...field, options: filteredOptions };
        }
        return field;
      }
    );
  }

  // Obtener anexos de tramite
  getAnexosTramite(idTramite: number) {
    this.cargueArchivosTramiteService
      .getTipoArchivosTramite(idTramite)
      .subscribe((response: any) => {

        this.anexosTramiteObligatorios = response.filter(
          (anexo: any) => anexo.requerido === true
        );
      });
  }

  // Función que maneja el evento del formulario inicial
  onSubmitCampoInicial(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    if (event.controlName === 'apoderado') {
      if (event.controlValue == 1) {
        this.mostrarApoderado = true;
        this.tieneApoderado = true;
      } else {
        this.tieneApoderado = false;
        this.mostrarApoderado = false;
        this.mostrarDatosApoderadoPN = false;
        this.mostrarDatosApoderadoPJ = false;
      }
    }
    if (event.form?.valid) {
      this.formInicialValido = true;
    }
  }

  // Función que maneja el evento del formulario de tipo de apoderado
  onSubmitApoderado(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    setTimeout(() => {
      this.formularioTipoApoderado = event.form;
    }, 300);
    // Se asigna el formulario y los valores de tipo de apoder
    let formGroup = event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    if (this.formInicialValido) {
      if (event.controlName === 'tipoPersonaApoderado') {
        this.tipoApoderado = event.controlValue;
      }
      if (this.tipoApoderado == 1) {
        this.mostrarDatosApoderadoPN = true;
        this.mostrarDatosApoderadoPJ = false;
        // Si existe el apoderado y cambia de tipo de persona, se limpian los campos del formulario
        if (this.existeApoderado) {
          this.datosBasicosApoderadoPN.map((field: FormField) => {
            field.value = '';
            return field;
          });
        }
        setTimeout(() => {
          this.getListaDocumentosApoderado();
        }, 1000);
      }

      if (this.tipoApoderado == 2) {
        this.mostrarDatosApoderadoPJ = true;
        this.mostrarDatosApoderadoPN = false;
        // Si existe el apoderado y cambia de tipo de persona, se limpian los campos del formulario
        if (this.existeApoderado) {
          this.datosBasicosApoderadoPJ.map((field: FormField) => {
            field.value = '';
            return field;
          });
        }
      }
    }
    const numeroDocumentoApoderado = this.campoApoderado.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      event.controlName == 'typeOfDocument' ||
      event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([Validators.required, Validators.maxLength(8)]);
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }

        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if (event.form?.valid) {
      this.formApoderadoValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos básicos del apoderado PN
  onSubmitDatosBasicosApoderadoPN(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioDatosBasicosApoderado = event.form;
    // Se valida si los campos de tipo o número de documento cambiaron
    if (event.controlName === 'typeOfDocument') {
      this.tipoDocumento = event.controlValue;
    } else if (event.controlName === 'numberOfDocument') {
      this.numeroDocumento = event.controlValue;
    } else {
      this.tipoDocumento = null;
      this.numeroDocumento = null;
    }
    // Se verifica si el formulario está válido
    if (event.form?.valid) {
      this.formDatosBasicosApoderadoValido = true;
    }
  }

  // Función que maneja el evento del formulario de ubicación del apoderado PN
  onSubmitUbicacionApoderadoPN(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioUbicacionApoderado = event.form;
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    const idPais = this.paises.find(
      item => item.Codigo == Constants.CODIGO_COLOMBIA
    )?.Id;
    if (event.form?.controls['country'].value == idPais) {
      event.form?.controls['departament'].addValidators(Validators.required);
      event.form?.controls['municipality'].addValidators(Validators.required);
      event.form?.controls['otroDepartamentoApoderado'].removeValidators(
        Validators.required
      );
      event.form?.controls[
        'otroDepartamentoApoderado'
      ].updateValueAndValidity();
      event.form?.controls['otroMunicipioApoderado'].removeValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioApoderado'].updateValueAndValidity();
    } else {
      let clearInputs: boolean = false;
      if (event.form?.controls['country'].value) {
        this.auxIdCountryApoderadoPN.push(
          event.form?.controls['country'].value
        );
        if (this.auxIdCountryApoderadoPN.length > 1) {
          clearInputs =
            event.form?.controls['country'].value !=
            this.auxIdCountryApoderadoPN[
            this.auxIdCountryApoderadoPN.length - 2
            ];
        }
      }
      if (clearInputs) {
        event.form?.controls['otroDepartamentoApoderado'].setValue('');
        event.form?.controls['otroMunicipioApoderado'].setValue('');
        this.auxIdCountryApoderadoPN = [];
      }
      event.form?.controls['departament'].removeValidators(Validators.required);
      event.form?.controls['municipality'].removeValidators(
        Validators.required
      );
      event.form?.controls['otroDepartamentoApoderado'].addValidators(
        Validators.required
      );
      event.form?.controls['otroDepartamentoApoderado'].markAsDirty();
      event.form?.controls['otroDepartamentoApoderado'].markAllAsTouched();
      event.form?.controls['otroMunicipioApoderado'].addValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioApoderado'].markAsDirty();
      event.form?.controls['otroMunicipioApoderado'].markAllAsTouched();
    }
    if (event.form?.valid) {
      this.formUbicacionApoderadoValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos de contacto del apoderado PN
  onSubmitContactoApoderadoPN(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioContactoApoderado = event.form;
    if (event.form?.valid) {
      this.formContactoApoderadoValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos básicos del apoderado PJ
  onSubmitDatosBasicosApoderadoPJ(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioDatosBasicosApoderadoPJ = event.form;
    // Se valida si los campos de tipo o número de documento cambiaron
    if (event.controlName === 'typeOfDocument') {
      this.tipoDocumento = event.controlValue;
    } else if (event.controlName === 'numberOfDocument') {
      this.numeroDocumento = event.controlValue;
    } else {
      this.tipoDocumento = null;
      this.numeroDocumento = null;
    }
    // Se verifica que el formulario sea válido
    if (event.form?.valid) {
      this.formDatosBasicosApoderadoPJValido = true;
    }
  }

  // Función que maneja el evento del formulario de ubicación del apoderado PJ
  onSubmitUbicacionApoderadoPJ(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioUbicacionApoderadoPJ = event.form;
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    const idPais = this.paises.find(
      item => item.Codigo == Constants.CODIGO_COLOMBIA
    )?.Id;
    if (event.form?.controls['country'].value == idPais) {
      event.form?.controls['departament'].addValidators(Validators.required);
      event.form?.controls['municipality'].addValidators(Validators.required);
      event.form?.controls['otroMunicipioApoderadoPJ'].removeValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioApoderadoPJ'].updateValueAndValidity();

      event.form?.controls['otroDepartamentoApoderadoPJ'].removeValidators(
        Validators.required
      );
      event.form?.controls[
        'otroDepartamentoApoderadoPJ'
      ].updateValueAndValidity();
    } else {
      let clearInputs: boolean = false;
      if (event.form?.controls['country'].value) {
        this.auxIdCountryApoderadoPJ.push(
          event.form?.controls['country'].value
        );
        if (this.auxIdCountryApoderadoPJ.length > 1) {
          clearInputs =
            event.form?.controls['country'].value !=
            this.auxIdCountryApoderadoPJ[
            this.auxIdCountryApoderadoPJ.length - 2
            ];
        }
      }
      if (clearInputs) {
        event.form?.controls['otroDepartamentoApoderadoPJ'].setValue('');
        event.form?.controls['otroMunicipioApoderadoPJ'].setValue('');
      }
      event.form?.controls['departament'].removeValidators(Validators.required);
      event.form?.controls['municipality'].removeValidators(Validators.required);
      event.form?.controls['otroDepartamentoApoderadoPJ'].addValidators(
        Validators.required
      );
      event.form?.controls['otroDepartamentoApoderadoPJ'].markAsDirty();
      event.form?.controls['otroDepartamentoApoderadoPJ'].markAllAsTouched();
      event.form?.controls['otroMunicipioApoderadoPJ'].addValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioApoderadoPJ'].markAsDirty();
      event.form?.controls['otroMunicipioApoderadoPJ'].markAllAsTouched();
    }

    if (event.form?.valid) {
      this.formUbicacionApoderadoPJValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos de contacto del apoderado PJ
  onSubmitContactoApoderadoPJ(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioContactoApoderadoPJ = event.form;
    if (event.form?.valid) {
      this.formContactoApoderadoPJValido = true;
    }
  }

  // Función que maneja el evento del formulario de tipo de demandante
  onSubmitDemandante(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    setTimeout(() => {
      this.formularioTipoDemandante = event.form;
    }, 100);
    if (event.controlName === 'tipoPersonaDemandante') {
      this.tipoDemandante = event.controlValue;
      if (this.tipoDemandante == 1) {
        if (this.esDemandantePN) {
          this.mostrarDatosDemandantePN = true;
          this.mostrarDatosDemandantePJ = false;
        } else {
          this.mostrarDatosDemandantePN = true;
          this.mostrarDatosDemandantePJ = false;
        }
      }
      if (this.tipoDemandante == 2) {
        if (this.esDemandantePJ) {
          this.mostrarDatosDemandantePJ = true;
          this.mostrarDatosDemandantePN = false;
        } else {
          this.mostrarDatosDemandantePJ = true;
          this.mostrarDatosDemandantePN = false;
        }
      }
    }
    if (event.form?.valid) {
      this.formDemandanteValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos básicos del demandante PN
  onSubmitDatosBasicosDemandantePN(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    setTimeout(() => {
      this.formularioDatosBasicosDemandante = event.form;
    }, 500);
    if (event.form?.valid) {
      this.formDatosBasicosDemandanteValido = true;

      const formValue = event.form.value;

      this.demandadoAux = {
        primerNombre: formValue.primerNombreDemandante,
        segundoNombre: formValue.segundoNombreDemandante,
        primerApellido: formValue.primerApellidoDemandante,
        segundoApellido: formValue.segundoApellidoDemandante
      };
    }
  }

  validarFormularioApoderadoPN($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoApoderadoPN = this.datosBasicosApoderadoPN.find(
      field => field.name == 'numberOfDocument'
    );
    if ($event.controlName == 'typeOfDocument') {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoApoderadoPN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoApoderadoPN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoApoderadoPN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoApoderadoPN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoApoderadoPN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoApoderadoPN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoApoderadoPN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoApoderadoPN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }

        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
  }

  validarFormularioApoderadoPJ($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoApoderadoPJ = this.datosBasicosApoderadoPJ.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (idTipoDocumento == 3) {
          if (numeroDocumentoApoderadoPJ != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoApoderadoPJ.errorMessages!['maxlength'] =
              this.crearDemandaText['crear-demanda']['nit-maxlength'];
            numeroDocumentoApoderadoPJ.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }

        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
  }

  validarFormularioDemandantePN($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoDemandantePN = this.datosBasicosDemandantePN.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoDemandantePN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandantePN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandantePN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandantePN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandantePN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(8),
                Validators.minLength(4),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandantePN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandantePN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandantePN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }

        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
  }

  validarFormularioDemandantePJ($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoDemandantePJ = this.datosBasicosDemandantePJ.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (idTipoDocumento == 3) {
          if (numeroDocumentoDemandantePJ != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandantePJ.errorMessages!['maxlength'] =
              this.crearDemandaText['crear-demanda']['nit-maxlength'];
            numeroDocumentoDemandantePJ.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }

        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
  }

  // Función que maneja el evento del formulario de ubicación del demandante PN
  onSubmitUbicacionDemandantePN(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioUbicacionDemandante = event.form;
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    const idPais = this.paises.find(
      item => item.Codigo == Constants.CODIGO_COLOMBIA
    )?.Id;
    if (event.form?.controls['country'].value == idPais) {
      event.form?.controls['departament'].addValidators(Validators.required);
      event.form?.controls['municipality'].addValidators(Validators.required);
      event.form?.controls['departamentoDemandante'].removeValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioDemandante'].removeValidators(
        Validators.required
      );
    } else {
      let clearInputs: boolean = false;
      if (event.form?.controls['country'].value) {
        this.auxIdCountryDemandantePN.push(
          event.form?.controls['country'].value
        );
        if (this.auxIdCountryDemandantePN.length > 1) {
          clearInputs =
            event.form?.controls['country'].value !=
            this.auxIdCountryDemandantePN[
            this.auxIdCountryDemandantePN.length - 2
            ];
        }
      }
      if (clearInputs) {
        event.form?.controls['departamentoDemandante'].setValue('');
        event.form?.controls['otroMunicipioDemandante'].setValue('');
        this.auxIdCountryDemandantePN = [];
      }
      event.form?.controls['departament'].removeValidators(Validators.required);
      event.form?.controls['municipality'].removeValidators(
        Validators.required
      );
      event.form?.controls['departamentoDemandante'].addValidators(
        Validators.required
      );
      event.form?.controls['departamentoDemandante'].markAsDirty();
      event.form?.controls['departamentoDemandante'].markAllAsTouched();
      event.form?.controls['otroMunicipioDemandante'].addValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioDemandante'].markAsDirty();
      event.form?.controls['otroMunicipioDemandante'].markAllAsTouched();
    }
    if (event.form?.valid) {
      this.formUbicacionDemandanteValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos de contacto del demandante PN
  onSubmitContactoDemandantePN(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioContactoDemandante = event.form;

    const formValue = event.form.value;
    if (formValue.correoElectronicoDemandante) {
      this.demandadoAux = {
        ...this.demandadoAux,
        correoElectronico: formValue.correoElectronicoDemandante
      };
    }

    if (event.form?.valid) {
      this.formContactoDemandanteValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos básicos del demandante PJ
  onSubmitDatosBasicosDemandantePJ(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    setTimeout(() => {
      this.formularioDatosBasicosDemandantePJ = event.form;
    }, 500);
    // Se valida si los campos de tipo o número de documento cambiaron
    if (event.form?.valid) {
      this.formDatosBasicosDemandantePJValido = true;
    }
  }

  // Función que maneja el evento del formulario de ubicación del demandante PJ
  onSubmitUbicacionDemandantePJ(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioUbicacionDemandantePJ = event.form;
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    const idPais = this.paises.find(
      item => item.Codigo == Constants.CODIGO_COLOMBIA
    )?.Id;
    if (event.form?.controls['country'].value == idPais) {
      event.form?.controls['departament'].addValidators(Validators.required);
      event.form?.controls['municipality'].addValidators(Validators.required);
      event.form?.controls['departamentoDemandantePJ'].removeValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioDemandantePJ'].removeValidators(
        Validators.required
      );
    } else {
      let clearInputs: boolean = false;
      if (event.form?.controls['country'].value) {
        this.auxIdCountryDemandantePJ.push(
          event.form?.controls['country'].value
        );
        if (this.auxIdCountryDemandantePJ.length > 1) {
          clearInputs =
            event.form?.controls['country'].value !=
            this.auxIdCountryDemandantePJ[
            this.auxIdCountryDemandantePJ.length - 2
            ];
        }
      }
      if (clearInputs) {
        event.form?.controls['departamentoDemandantePJ'].setValue('');
        event.form?.controls['otroMunicipioDemandantePJ'].setValue('');
      }
      event.form?.controls['departament'].removeValidators(Validators.required);
      event.form?.controls['municipality'].removeValidators(Validators.required);
      event.form?.controls['departamentoDemandantePJ'].addValidators(
        Validators.required
      );
      event.form?.controls['departamentoDemandantePJ'].markAsDirty();
      event.form?.controls['departamentoDemandantePJ'].markAllAsTouched();
      event.form?.controls['otroMunicipioDemandantePJ'].addValidators(
        Validators.required
      );
      event.form?.controls['otroMunicipioDemandantePJ'].markAsDirty();
      event.form?.controls['otroMunicipioDemandantePJ'].markAllAsTouched();
    }
    if (event.form?.valid) {
      this.formUbicacionDemandantePJValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos de contacto del demandante PJ
  onSubmitContactoDemandantePJ(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    this.formularioContactoDemandantePJ = event.form;
    if (event.form?.valid) {
      this.formContactoDemandantePJValido = true;
    }
  }

  // Función que maneja el evento del formulario de datos del caso
  onSubmitCaso(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.validarFormularios();
    const pretension = event.form?.controls['tipoPretension'].value;
    const listaPretension = this.listaTiposPretension.find(
      item => item.Id == pretension
    );
    this.tipoCasoSeleccionado = listaPretension?.Codigo;
    const tipoCaso = this.listaTiposCasos.find(item =>
      item.Id == event.form?.controls['tipoCaso'].value);
    if (listaPretension?.Codigo == 'TP_DGRPBS') {
      this.camposCaso.forEach(field => {
        if (field.name == 'tipoCaso') {
          field.required = true;
        }
      });
      event.form?.controls['tipoCaso'].addValidators(Validators.required);
    } else {
      this.camposCaso.forEach(field => {
        if (field.name == 'tipoCaso') {
          field.required = false;
        }
      });
      event.form?.controls['tipoCaso'].setValue(null);
      event.form?.controls['tipoCaso'].removeValidators(Validators.required);
    }

    if (event.controlName === 'tipoPretension') {
      this.mostrarCargueArchivos = false;
      setTimeout(() => {
        this.mostrarCargueArchivos = true;
      }, 100);
    }

    if (event.controlName === 'tipoCaso') {
      this.mostrarCargueArchivos = false;
      if (event.form?.controls['tipoPretension'].value && event.controlValue) {
        if (this.tipoCasoSeleccionado === 'TP_DGRPBS') {
          this.jsonCasoPretension = null;
          if (tipoCaso && this.tipoCasoSeleccionado) {
            this.jsonCasoDemanda = {
              tipoPretension: this.tipoCasoSeleccionado,
              tipoDemanda: tipoCaso.Codigo
            }
          }
        }
      }
      setTimeout(() => {
        this.mostrarCargueArchivos = true;
      }, 100);
    }

    if (event.controlName === 'descripcionDemanda') {
      this.mostrarCargueArchivos = true;
    }

    if (event.form?.get('tipoPretension')?.value === null) {
      setTimeout(() => {
        this.mostrarCargueArchivos = false;
      }, 100);
    }

    // if (event.form?.valid) {
    this.formularioCaso = event.form;
    if (this.tipoCasoSeleccionado === 'TP_DGRPBS') {
      this.jsonCasoPretension = null;
      if (tipoCaso && this.tipoCasoSeleccionado) {
        this.jsonCasoDemanda = {
          tipoPretension: this.tipoCasoSeleccionado,
          tipoDemanda: tipoCaso.Codigo
        }
      }
    }
    // }
  }

  onSubmitAceptarPoliticas(event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formularioAceptarPoliticas = event.form;
    this.validarFormularios();
  }

  // Función que maneja el evento del formulario de datos finales
  onSubmitDatosFinales(
    event: {
      controlName?: string;
      controlValue: unknown;
      form: FormGroup;
    },
    action: string
  ) {
    this.validarFormularios();
    this.recaptchaV3Service.execute(action).subscribe((token: string) => {
      this.recaptchaService
        .verificarTokenRecaptcha({ token: token })
        .subscribe(response => {
          if (response.success && event.form?.valid) {
            this.recaptchaValido = true;
            this.formularioFinal = event.form;
            this.validarFormularios();
          }
        });
    });
  }

  listarMunicipios(idDepartamento: number): Observable<MunicipioDto[]> {
    return this.listaService.getMunicipalityList(idDepartamento);
  }

  // Función que valida si los archivos fueron cargados corectamente
  validarCargueArchivos(archivosCargados: boolean) {
    this.enviarDocumentos = false;
    if (archivosCargados) {
      this.archivosCargados = true;
    } else {
      this.archivosCargados = false;
    }
    this.validarFormularios();
  }

  // Función que consume el servicio que valida por medio del tipo y número de documento
  // si el apoderado ya se encuentra registrado
  validarApoderado(tipo: unknown, numero: unknown, form: FormGroup) {
    if (typeof tipo === 'object' && tipo !== null && 'Id' in tipo) {
      const id = (tipo as { Id: number }).Id;
      if (typeof numero == 'string') {
        this.demandaService
          .verificarPersona(id, numero)
          .subscribe((resp: PersonaDTO) => {
            if (resp) {
              this.existeApoderado = true;
              this.idApoderado = resp.Id;
              resp = this.textTransformService.transformarAMayusculas(resp);
              if (resp.Id_Tipo_Persona == 1) {
                if (resp.Persona_Natural) {
                  this.datosBasicosApoderadoPN =
                    this.datosBasicosApoderadoPN.map((field: FormField) => {
                      switch (field.name) {
                        case 'typeOfDocument':
                          field.value = resp.Id_Tipo_Identificacion;
                          break;
                        case 'numberOfDocument':
                          field.value = resp.Identificacion;
                          break;
                        case 'primerNombreApoderado':
                          field.value = resp.Persona_Natural[0].Primer_nombre;
                          break;
                        case 'segundoNombreApoderado':
                          field.value = resp.Persona_Natural[0].Segundo_nombre;
                          break;
                        case 'primerApellidoApoderado':
                          field.value = resp.Persona_Natural[0].Primer_apellido;
                          break;
                        case 'segundoApellidoApoderado':
                          field.value =
                            resp.Persona_Natural[0].Segundo_apellido;
                          break;
                      }
                      return field;
                    });
                }
              }
              if (resp.Id_Tipo_Persona == 2) {
                if (
                  resp.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona
                ) {
                  this.datosBasicosApoderadoPJ =
                    this.datosBasicosApoderadoPJ.map((field: FormField) => {
                      switch (field.name) {
                        case 'typeOfDocument':
                          field.value = resp.Id_Tipo_Identificacion;
                          break;
                        case 'numberOfDocument':
                          field.value = resp.Identificacion;
                          break;
                        case 'razonSocial':
                          field.value =
                            resp.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social;
                          break;
                      }
                      return field;
                    });
                }
              }
            } else {
              this.existeApoderado = false;
            }
          });
      }
    }
  }

  // Metodo que setea el valor para el demandante por medio de los datos de inicio sesion
  getDataUsuario() {
    this.dataUsuario = this.textTransformService.transformarAMayusculas(this.dataUsuario);

    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ||
      localStorage.getItem(Constants.USER_TYPE) ||
      '{}'
    );

    const esExtranjero = this.dataUsuario?.pais !== 1;

    if (esExtranjero) {
      this._cuentaService.getDataPersonal(this.dataUsuario.idUsuario!).subscribe((response: any) => {
        if (response.status === 200) {
          this.dataUsuario.otroDepartamento = response.data.Otro_Departamento;
          this.dataUsuario.otroMunicipio = response.data.Otro_Municipio;
        }

        if (user_type.Nombre === Constants.ROL_ABOGADO) {
          this.procesarDatosApoderado();
        } else {
          this.procesarDatosDemandante();
        }
      });
    } else {
      if (user_type.Nombre === Constants.ROL_ABOGADO) {
        this.procesarDatosApoderado();
      } else {
        this.procesarDatosDemandante();
      }
    }
  }

  private procesarDatosApoderado() {
    this.campoInicial = this.campoInicial.map(field => {
      if (field.name === 'apoderado') field.value = 1;
      return field;
    });

    this.campoApoderado = this.campoApoderado.map(field => {
      if (field.name === 'tipoPersonaApoderado') {
        field.value = this.dataUsuario?.tipoPersona;
      }
      return field;
    });

    this.mostrarDatosApoderadoPN = this.dataUsuario?.tipoPersona === 1;
    this.mostrarDatosApoderadoPJ = this.dataUsuario?.tipoPersona === 2;

    this.datosBasicosApoderadoPN = this.datosBasicosApoderadoPN.map(field => {
      const map = {
        typeOfDocument: this.getIdDocumento(this.dataUsuario?.tipoDocumento?.toString()!) ?? undefined,
        numberOfDocument: this.dataUsuario?.identificacion,
        primerNombreApoderado: this.dataUsuario?.primerNombre,
        segundoNombreApoderado: this.dataUsuario?.segundoNombre,
        primerApellidoApoderado: this.dataUsuario?.primerApellido,
        segundoApellidoApoderado: this.dataUsuario?.segundoApellido,
      };
      field.value = map[field.name as keyof typeof map];
      return field;
    });

    this.ubicacionApoderadoPN = this.ubicacionApoderadoPN.map(field => {
      const map = {
        country: this.dataUsuario?.pais,
        departament: this.dataUsuario?.departamento,
        municipality: this.dataUsuario?.municipio,
        otroMunicipioApoderado: this.dataUsuario?.otroMunicipio,
        otroDepartamentoApoderado: this.dataUsuario?.otroDepartamento,
        direccionApoderado:
          this.dataUsuario?.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ??
          this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
      };
      field.value = map[field.name as keyof typeof map];
      return field;
    });

    this.datosContactoApoderadoPN = this.datosContactoApoderadoPN.map(field => {
      if (field.name === 'correoElectronicoApoderado') {
        field.value = this.dataUsuario?.correoElectronico ?? undefined;
      }
      return field;
    });
  }

  private procesarDatosDemandante() {
    this.campoDemandante = this.campoDemandante.map(field => {
      if (field.name === 'tipoPersonaDemandante') {
        field.value = this.dataUsuario?.tipoPersona;
      }
      return field;
    });

    if (this.dataUsuario?.tipoPersona === Constants.TIPO_PERSONA.NATURAL) {
      this.esDemandantePN = true;
      this.esDemandantePJ = false;
      this.mostrarDatosDemandantePN = true;
      this.mostrarDatosDemandantePJ = false;

      const personaNatural: FielDatosPersonaNaturalDTO = {
        idUsuario: this.dataUsuario.idUsuario,
        tipoPersona: this.dataUsuario.tipoPersona,
        primerNombreDemandante: this.dataUsuario.primerNombre,
        segundoNombreDemandante: this.dataUsuario.segundoNombre,
        primerApellidoDemandante: this.dataUsuario.primerApellido,
        segundoApellidoDemandante: this.dataUsuario.segundoApellido,
        typeOfDocument: this.getIdDocumento(String(this.dataUsuario.tipoDocumento)),
        numberOfDocument: this.dataUsuario.identificacion,
        correoElectronicoDemandante: this.dataUsuario.correoElectronico ?? '',
        country: this.dataUsuario.pais,
        departament: this.dataUsuario.departamento,
        municipality: this.dataUsuario.municipio,
        departamentoDemandante: this.dataUsuario.otroDepartamento,
        otroMunicipioDemandante: this.dataUsuario.otroMunicipio,
        direccionDemandante:
          this.dataUsuario.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ??
          this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
        celularDemandante: this.dataUsuario.telefonoPrincipal,
      };

      this.mapearDatosPersonaNatural(personaNatural);
    }

    if (this.dataUsuario?.tipoPersona === Constants.TIPO_PERSONA.JURIDICA) {
      this.esDemandantePJ = true;
      this.esDemandantePN = false;
      this.mostrarDatosDemandantePJ = true;
      this.mostrarDatosDemandantePN = false;

      const personaJuridica: FielDatosPersonaJuridicaDTO = {
        idUsuario: this.dataUsuario.idUsuario,
        tipoPersona: this.dataUsuario.tipoPersona,
        razonSocialDemandante: this.dataUsuario.razonSocial,
        typeOfDocument: this.getIdDocumento(String(this.dataUsuario.tipoDocumento)),
        numberOfDocument: this.dataUsuario.identificacion,
        correoElectronicoDemandantePJ: this.dataUsuario.correoElectronico ?? '',
        country: this.dataUsuario.pais,
        departament: this.dataUsuario.departamento,
        municipality: this.dataUsuario.municipio,
        departamentoDemandantePJ: this.dataUsuario.otroDepartamento,
        otroMunicipioDemandantePJ: this.dataUsuario.otroMunicipio,
        direccionDemandantePJ:
          this.dataUsuario.direccion?.find(e => e.Es_Primaria)?.Direccion_Notificacion ??
          this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '',
        celularDemandantePJ: this.dataUsuario.telefonoPrincipal,
      };

      this.mapearDatosPersonaJuridica(personaJuridica);
    }
  }


  mapearDatosPersonaNatural(dataPersona: FielDatosPersonaNaturalDTO) {
    setTimeout(() => {
      this.datosBasicosDemandantePN = this.datosBasicosDemandantePN.map(
        field => {
          if (
            dataPersona[field.name as keyof typeof dataPersona] !== undefined
          ) {
            field.value = dataPersona[field.name as keyof typeof dataPersona];
          }
          return field;
        }
      );
    }, 400);

    setTimeout(() => {
      this.ubicacionDemandantePN = this.ubicacionDemandantePN.map(field => {
        if (dataPersona[field.name as keyof typeof dataPersona] !== undefined) {
          field.value = dataPersona[field.name as keyof typeof dataPersona];
        }
        return field;
      });
    }, 1000);
    setTimeout(() => {
      this.datosContactoDemandantePN = this.datosContactoDemandantePN.map(
        field => {
          if (
            dataPersona[field.name as keyof typeof dataPersona] !== undefined
          ) {
            field.value = dataPersona[field.name as keyof typeof dataPersona];
          }
          return field;
        }
      );
    }, 500);
  }

  mapearDatosPersonaJuridica(dataPersona: FielDatosPersonaJuridicaDTO) {
    let personTypeId: string = dataPersona.tipoPersona!.toString();
    this.datosBasicosDemandantePJ = this.datosBasicosDemandantePJ.map(field => {
      if (dataPersona[field.name as keyof typeof dataPersona] !== undefined) {
        field.value = dataPersona[field.name as keyof typeof dataPersona];
      }
      if (field.name == 'typeOfDocument') {
        if (
          personTypeId === '1' ||
          personTypeId === '2' ||
          personTypeId === undefined
        ) {
          field.personTypeId = personTypeId;
        }
      }
      return field;
    });
    setTimeout(() => {
      this.ubicacionDemandantePJ = this.ubicacionDemandantePJ.map(field => {
        if (dataPersona[field.name as keyof typeof dataPersona] !== undefined) {
          field.value = dataPersona[field.name as keyof typeof dataPersona];
        }
        return field;
      });
    }, 1000);

    this.datosContactoDemandantePJ = this.datosContactoDemandantePJ.map(
      field => {
        if (dataPersona[field.name as keyof typeof dataPersona] !== undefined) {
          field.value = dataPersona[field.name as keyof typeof dataPersona];
        }
        return field;
      }
    );
  }

  getIdDocumento(tipoDocumento: string): number {
    const documento = this.tiposDocumento.find(
      (elemento: TipoDocumentoDto) => elemento.Tipo_Documento === tipoDocumento
    );
    return documento ? +documento.Id : 0;
  }

  protected readonly TablaDefinicionesComponent = TablaDefinicionesComponent;

  // Se consume el servicio de registrar trámite
  async guardarTramite(
    esEnviar: boolean
  ): Promise<{ success: boolean; message?: string }> {
    if (esEnviar) {
      if (!this.archivosCargados) {
        this.modalService.error(
          this.alertaText['error'],
          this.alertaText['archivos_obligatorios']
        );
        return { success: false };
      }
      if (!this.formulariosValidos) {
        this.markFormsAsTouched();
        this.formularioAceptarPoliticas.markAllAsTouched();
        if (this.formularioFinal) {
          this.formularioFinal.markAllAsTouched();
        }
        this.modalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        return { success: false };
      }
    }

    this.enviarEntidad = esEnviar;


    const idMunicipioApoderado =
      this.formularioTipoApoderado?.controls['tipoPersonaApoderado'].value === 1
        ? this.formularioUbicacionApoderado?.controls['municipality'].value
        : this.formularioUbicacionApoderadoPJ?.controls['municipality'].value;

    const idMunicipioDemandante =
      this.formularioTipoDemandante?.controls['tipoPersonaDemandante'].value ===
        1
        ? this.formularioUbicacionDemandante?.controls['municipality'].value
        : this.formularioUbicacionDemandantePJ.controls['municipality'].value;

    const tramite: TramiteSupersaludDTO = {
      id: this.idTramite ?? null,
      idTipoTramite: Constants.ID_TIPO_TRAMITE,
      apoderado: this.tieneApoderado
        ? {
          id: this.idApoderado ?? null,
          idTipoPersona:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value ?? null,
          primerNombre:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioDatosBasicosApoderado?.controls[
                'primerNombreApoderado'
              ].value
              : null,
          segundoNombre:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioDatosBasicosApoderado?.controls[
                'segundoNombreApoderado'
              ].value
              : null,
          primerApellido:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioDatosBasicosApoderado?.controls[
                'primerApellidoApoderado'
              ].value
              : null,
          segundoApellido:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioDatosBasicosApoderado?.controls[
                'segundoApellidoApoderado'
              ].value
              : null,
          idTipoIdentificacion:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioDatosBasicosApoderado?.controls[
                'typeOfDocument'
              ].value
              : this.formularioDatosBasicosApoderadoPJ?.controls[
                'typeOfDocument'
              ].value,
          identificacion:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioDatosBasicosApoderado?.controls[
                'numberOfDocument'
              ].value
              : this.formularioDatosBasicosApoderadoPJ?.controls[
                'numberOfDocument'
              ].value,
          razonSocial:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 2
              ? this.formularioDatosBasicosApoderadoPJ?.controls[
                'razonSocial'
              ].value
              : null,
          telefonoPrincipal:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioContactoApoderado?.controls['celularApoderado']
                .value
              : this.formularioContactoApoderadoPJ?.controls[
                'celularApoderadoPJ'
              ].value,
          telefonoSecundario:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioContactoApoderado?.controls[
                'telefonoApoderado'
              ].value
              : this.formularioContactoApoderadoPJ?.controls[
                'telefonoApoderadoPJ'
              ].value,
          correoElectronico:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioContactoApoderado?.controls[
                'correoElectronicoApoderado'
              ].value
              : this.formularioContactoApoderadoPJ?.controls[
                'correoElectronicoApoderadoPJ'
              ].value,
          municipio: {
            id: idMunicipioApoderado,
          },
          direccionPersona: [
            {
              direccionNotificacion:
                this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
                  .value === 1
                  ? this.formularioUbicacionApoderado?.controls[
                    'direccionApoderado'
                  ].value
                  : this.formularioUbicacionApoderadoPJ?.controls[
                    'direccionApoderadoPJ'
                  ].value,
            },
          ],
          ciudadExtranjero:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioUbicacionApoderado?.controls[
                'otroMunicipioApoderado'
              ].value
              : this.formularioUbicacionApoderadoPJ?.controls[
                'otroMunicipioApoderadoPJ'
              ].value,
          departamentoExtranjero:
            this.formularioTipoApoderado?.controls['tipoPersonaApoderado']
              .value === 1
              ? this.formularioUbicacionApoderado?.controls[
                'otroDepartamentoApoderado'
              ].value
              : this.formularioUbicacionApoderadoPJ?.controls[
                'otroDepartamentoApoderadoPJ'
              ].value,
        }
        : null,
      demandante: [
        {
          id: this.idDemandante ?? null,
          idTipoPersona:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value ?? null,
          primerNombre:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioDatosBasicosDemandante?.controls[
                'primerNombreDemandante'
              ].value
              : null,
          segundoNombre:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioDatosBasicosDemandante?.controls[
                'segundoNombreDemandante'
              ].value
              : null,
          primerApellido:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioDatosBasicosDemandante?.controls[
                'primerApellidoDemandante'
              ].value
              : null,
          segundoApellido:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioDatosBasicosDemandante?.controls[
                'segundoApellidoDemandante'
              ].value
              : null,
          razonSocial:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 2
              ? this.formularioDatosBasicosDemandantePJ?.controls[
                'razonSocialDemandante'
              ].value
              : null,
          idTipoIdentificacion:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioDatosBasicosDemandante?.controls[
                'typeOfDocument'
              ].value
              : this.formularioDatosBasicosDemandantePJ?.controls[
                'typeOfDocument'
              ].value,
          identificacion:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioDatosBasicosDemandante?.controls[
                'numberOfDocument'
              ].value
              : this.formularioDatosBasicosDemandantePJ?.controls[
                'numberOfDocument'
              ].value,
          telefonoPrincipal:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioContactoDemandante?.controls['celularDemandante']
                .value
              : this.formularioContactoDemandantePJ?.controls[
                'celularDemandantePJ'
              ].value,
          telefonoSecundario:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioContactoDemandante?.controls[
                'telefonoDemandante'
              ].value
              : this.formularioContactoDemandantePJ?.controls[
                'telefonoDemandantePJ'
              ].value,
          correoElectronico:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioContactoDemandante?.controls[
                'correoElectronicoDemandante'
              ].value
              : this.formularioContactoDemandantePJ.controls[
                'correoElectronicoDemandantePJ'
              ].value,
          municipio: {
            id: idMunicipioDemandante,
          },
          direccionPersona: [
            {
              direccionNotificacion:
                this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
                  .value === 1
                  ? this.formularioUbicacionDemandante?.controls[
                    'direccionDemandante'
                  ].value
                  : this.formularioUbicacionDemandantePJ?.controls[
                    'direccionDemandantePJ'
                  ].value,
            },
            {
              direccionNotificacion:
                this.formularioUbicacionDemandantePJ?.controls[
                  'direccionComercialDemandantePJ'
                ].value ?? null,
            },
          ],
          ciudadExtranjero:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioUbicacionDemandante?.controls[
                'otroMunicipioDemandante'
              ].value
              : this.formularioUbicacionDemandantePJ?.controls[
                'otroMunicipioDemandantePJ'
              ].value,
          departamentoExtranjero:
            this.formularioTipoDemandante?.controls['tipoPersonaDemandante']
              .value === 1
              ? this.formularioUbicacionDemandante?.controls[
                'departamentoDemandante'
              ].value
              : this.formularioUbicacionDemandantePJ?.controls[
                'departamentoDemandantePJ'
              ].value,
        },
      ],
      tipoPretension: this.formularioCaso?.controls['tipoPretension'].value
        ? this.listaTiposPretension.find(
          item =>
            item.Id == this.idTipoCasoSeleccionado
        )
        : undefined,
      detalleDemanda:
        this.formularioCaso?.controls['descripcionDemanda'].value ?? null,
      tipoDemanda: this.formularioCaso?.controls['tipoCaso'].value
        ? this.listaTiposCasos.find(
          item => item.Id == this.formularioCaso?.controls['tipoCaso'].value
        )
        : undefined,
      medioEnvio: this.formularioFinal?.controls['medioEnvio'].value ?? null,
      noRobot: this.recaptchaValido ? true : false,
      autorizoEnvio: this.enviarCorreoDemandado,
      enviar: esEnviar,
      aceptoPoliticas: this.formularioAceptarPoliticas.controls['politicas'].value,
      aceptoEnvioCopiaDemanda: this.confirmacionEnvio,
      usuario: {
        id: this.idUsuario ?? null,
      },
      idioma: this.idiomaActual,
    };
    try {
      const response = await firstValueFrom(
        this.demandaService.guardarTramite(tramite)
      );

      if (response && response.id) {
        this.idTramite = response.id;
        this.enviarDocumentos = true;
      }
      if (!esEnviar) {
        await this.modalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          this.alertaText['supersalud-alertas']['tramite-enviado-mensaje'].replace('{{proceso}}', this.proceso)
        );
        if (response && response.id) {
          return { success: true };
        } else {
          return { success: false };
        }
      } else {
        await this.modalService.exito(
          this.alertaText['supersalud-alertas']['solicitud-creada'],
          this.alertaText['supersalud-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad)
        );
        this.router.navigate(['/expediente']);
        return { success: true };
      }
    } catch (error) {
      return { success: false };
      // await this.modalService.error(`${error}`);
    }
  }

  markFormsAsTouched() {

    // Marcar todos los <app-form>
    if (this.personaComponentes && this.personaComponentes.length > 0) {
      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });
    }
  }

  // Función que valida los formularios de apoderado, demandante y caso
  validarFormularios() {

    const tipoApoderado = this.formularioTipoApoderado?.get('tipoPersonaApoderado')?.value;
    const tipoDemandante = this.formularioTipoDemandante?.get('tipoPersonaDemandante')?.value;

    const formApo = tipoApoderado === Constants.TIPO_PERSONA.NATURAL
      ? this.formularioDatosBasicosApoderado
      : this.formularioDatosBasicosApoderadoPJ;

    const formDem = tipoDemandante === Constants.TIPO_PERSONA.NATURAL
      ? this.formularioDatosBasicosDemandante
      : this.formularioDatosBasicosDemandantePJ;

    const ctrlApoderado = formApo?.get('numberOfDocument');
    const ctrlDemandante = formDem?.get('numberOfDocument');

    const numeroApoderado = ctrlApoderado?.value;
    const numeroDemandante = ctrlDemandante?.value;

    if (numeroApoderado && numeroDemandante && numeroApoderado === numeroDemandante) {
      this.setErrorMismoDocumento(ctrlApoderado, true);
      this.setErrorMismoDocumento(ctrlDemandante, true);
    } else {
      this.setErrorMismoDocumento(ctrlApoderado, false);
      this.setErrorMismoDocumento(ctrlDemandante, false);
    }
    let apoderadoValido = false;
    let demandanteValido = false;
    let casoValido = false;
    let aceptoPoliticas = false;
    let datosfinalesValido = false;
    let tipoPersonaApoderado =
      this.formularioTipoApoderado?.controls['tipoPersonaApoderado'].value;
    let tipoPersonaDemandante =
      this.formularioTipoDemandante?.controls['tipoPersonaDemandante'].value;
    if (this.tieneApoderado) {
      // Se validan los formularios del apoderado de acuerdo al tipo de persona (natural o jurídica)
      if (tipoPersonaApoderado === 1) {
        if (
          this.formularioDatosBasicosApoderado?.valid &&
          this.formularioUbicacionApoderado?.valid &&
          this.formularioContactoApoderado?.valid
        ) {
          apoderadoValido = true;
        } else {
          apoderadoValido = false;
        }
      } else if (tipoPersonaApoderado === 2) {
        if (
          this.formularioDatosBasicosApoderadoPJ?.valid &&
          this.formularioUbicacionApoderadoPJ?.valid &&
          this.formularioContactoApoderadoPJ?.valid
        ) {
          apoderadoValido = true;
        } else {
          apoderadoValido = false;
        }
      }
    } else {
      apoderadoValido = true;
    }
    // Se validan los formularios del demandante de acuerdo al tipo de persona (natural o jurídica)
    if (tipoPersonaDemandante === 1) {
      if (
        this.formularioDatosBasicosDemandante?.valid &&
        this.validarUbicacionDemandante(1) &&
        this.formularioContactoDemandante?.valid
      ) {
        demandanteValido = true;
      } else {
        demandanteValido = false;
      }
    } else if (tipoPersonaDemandante === 2) {
      if (
        this.formularioDatosBasicosDemandantePJ?.valid &&
        this.validarUbicacionDemandante(2) &&
        this.formularioContactoDemandantePJ?.valid
      ) {
        demandanteValido = true;
      } else {
        demandanteValido = false;
      }
    }

    // Se valida el formulario de descripción del caso
    if (this.formularioCaso?.valid) {
      casoValido = true;
    } else {
      casoValido = false;
    }

    //Se valida que haya leido politicas.
    if (this.formularioAceptarPoliticas?.get('politicas')?.value) {
      aceptoPoliticas = true;
    } else {
      aceptoPoliticas = false;
    }

    // Se valida el formulario final
    if (this.formularioFinal?.valid) {
      datosfinalesValido = true;
    } else {
      datosfinalesValido = false;
    }

    if (
      apoderadoValido &&
      demandanteValido &&
      casoValido &&
      datosfinalesValido &&
      aceptoPoliticas &&
      this.archivosCargados
    ) {
      this.formulariosValidos = true;
    } else {
      this.formulariosValidos = false;
    }
  }

  validarUbicacionDemandante(tipoPersona: number) {
    if (tipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      const pais =
        +this.formularioUbicacionDemandante?.controls['country']?.value;
      if (pais == 1) {
        return (
          this.formularioUbicacionDemandante?.controls['departament']?.value !==
          undefined &&
          this.formularioUbicacionDemandante?.controls['direccionDemandante']
            ?.value !== undefined &&
          this.formularioUbicacionDemandante?.controls['municipality']
            ?.value !== undefined
        );
      } else {
        return (
          this.formularioUbicacionDemandante?.controls['direccionDemandante']
            ?.value !== undefined &&
          this.formularioUbicacionDemandante?.controls['departamentoDemandante']
            ?.value !== undefined &&
          this.formularioUbicacionDemandante?.controls[
            'otroMunicipioDemandante'
          ]?.value !== undefined
        );
      }
    } else {
      const pais =
        +this.formularioUbicacionDemandantePJ?.controls['country']?.value;
      if (pais == 1) {
        return (
          this.formularioUbicacionDemandantePJ?.controls['departament']
            ?.value !== undefined &&
          this.formularioUbicacionDemandantePJ?.controls[
            'direccionDemandantePJ'
          ]?.value !== undefined &&
          this.formularioUbicacionDemandantePJ?.controls['municipality']
            ?.value !== undefined
        );
      } else {
        return (
          this.formularioUbicacionDemandantePJ?.controls[
            'direccionDemandantePJ'
          ]?.value !== undefined &&
          this.formularioUbicacionDemandantePJ?.controls[
            'departamentoDemandantePJ'
          ]?.value !== undefined &&
          this.formularioUbicacionDemandantePJ?.controls[
            'otroMunicipioDemandantePJ'
          ]?.value !== undefined
        );
      }
    }
  }

  // Se valida que el primer nombre y el primer apellido del demandante estén diligenciados
  /* validarCamposDemandante(): boolean {
     if (
       this.formularioTipoDemandante?.controls['tipoPersonaDemandante'].value ===
       1
     ) {
       if (
         this.formularioDatosBasicosDemandante?.controls[
           'primerNombreDemandante'
         ].value &&
         this.formularioDatosBasicosDemandante?.controls[
           'primerApellidoDemandante'
         ].value
       ) {
         return true;
       } else {
         return false;
       }
     } else {
       return true;
     }
   }*/

  isEmptyAnexo(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    if (requeridosFull == cantidadRequeridos) {
      return true;
    } else {
      return false;
    }
  }

  validarDocumentosObligatorios(): boolean {
    const anexosRequeridosIds = this.anexosTramiteObligatorios.map(
      (anexo: any) => anexo.id
    );
    return this.isEmptyAnexo(this.filesUpload, anexosRequeridosIds);
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    this.filesUpload = archivos;
    const totalBytes = archivos.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);
  }

  validarCheck(evento: any) {
    this.confirmacionEnvio = evento.target.checked;
  }

  get correoDemandado(): string {
    return this.demandadoAux?.correoElectronico ?? '';
  }

  get nombreDemandado(): string {
    const d = this.demandadoAux;
    return `${d.primerNombre ?? ''} ${d.segundoNombre ?? ''} ${d.primerApellido ?? ''} ${d.segundoApellido ?? ''}`.trim();
  }

  rechazarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = false;
    this.modalService.exito(
      this.comunText['accion-cancelada'],
      this.comunText['rechazo-envio']
    );
  }

  aceptarEnvio() {
    this.seleccionAceptoRechazoEnvio = true;
    this.enviarCorreoDemandado = true;

    this.modalService.exito(
      this.comunText['envio-confirmado'],
      this.comunText['acepta-copia']
    );
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }
  setErrorMismoDocumento(control: any, marcar: boolean) {
    if (!control) return;

    const errors = control.errors || {};

    if (marcar) {
      control.setErrors({ ...errors, mismoDocumento: true });
    } else {
      if (errors['mismoDocumento']) {
        delete errors['mismoDocumento'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
  }

  getStorageItem(key: string): string | null {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  }
}
